<template>
  <v-app>
    <v-main class="v-content">
      <NavBar v-if="displayNavBar" />
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from './components/navbar.vue'

export default {
  name: 'App',
  components: {
    NavBar,
  },
  computed: {
    displayNavBar () {
      return this.removeSidebarRoute.indexOf(this.$route.name) < 0
    }
  },
  created () {
    if (this.$isUserLoggedIn() && this.$route.path !== '/getAppData') {
      this.$router.push({ name: 'GetAppData', params: { nextRoute: this.$route } })
    }
  },
  data: () => ({
    removeSidebarRoute: ['Login', 'GetAppData', '401', '404'],
  }),
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap');
</style>
<style lang="css">
.v-application {
  font-family: 'Quicksand', sans-serif;
}
@media print{
  .v-content {
    padding: 0 !important;
  }
}
</style>
